// ABOUTME: Modal component that displays shipped/processed orders on mobile.
// ABOUTME: Opened by tapping the processed counter pill in the echeck mobile header.

import { useTheme } from "@emotion/react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../components/theme/text/Subheading";
import { tokens } from "../../../../theme";
import SHModal from "../../../../components/theme/Modal/SHModal";
import ShippedOrders from "./ShippedOrders";

const MShippedOrdersModal = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    return (
        <SHModal
            open={props.open}
            onClose={props.onClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1,
                }}
            >
                <Subheading>{t("processed")}</Subheading>

                <ToggleButtonGroup
                    color={props.filterBySelectedWorkSpace ? "green" : "red"}
                    value={props.filterBySelectedWorkSpace}
                    exclusive
                    onChange={props.toggleFilterBySelectedWorkSpace}
                    aria-label="Active"
                    className={cx(`${props.filterBySelectedWorkSpace}`, {
                        'active': props.filterBySelectedWorkSpace === "true"
                    })}
                    sx={{
                        background: theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[200],
                        padding:0.5,
                        borderRadius:5,
                        transition:"250ms",
                        "&.active" : {
                            background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                            transition:"250ms",
                        },
                    }}
                >
                    <ToggleButton
                        sx={{
                            flex:1,
                            padding: 0,
                            paddingX: 2,
                            border: 0,
                            lineHeight: "32px",
                            whiteSpace:"nowrap",
                            textTransform: "unset",
                            borderRadius: "32px !important",
                            color:props.filterBySelectedWorkSpace ? theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]:  "#fff",
                            background: props.filterBySelectedWorkSpace === false ? colors.grey[400] : "transparent",
                            transition: "250ms",
                            "&.Mui-selected": {
                                background: colors.grey[400],
                                color: "#fff",
                                fontWeight:"bold",
                            },
                            "&.Mui-selected:hover": {
                                background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                            },
                        }}
                        value={false}
                    >
                        {t('all')}
                    </ToggleButton>
                    <ToggleButton
                        sx={{
                            flex:1,
                            padding: 0,
                            paddingX: 2,
                            border: 0,
                            whiteSpace:"nowrap",
                            lineHeight: "32px",
                            textTransform: "unset",
                            borderRadius: "32px !important",
                            color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                            background: props.filterBySelectedWorkSpace === true ? theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] : "transparent",
                            transition: "250ms",
                            "&.Mui-selected": {
                                background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] :  colors.txt["white"],
                                fontWeight:"bold",
                            },
                            "&.Mui-selected:hover": {
                                background:theme.palette.mode === "dark" ? "#5C95FF" : "#004CDB"
                            },
                        }}
                        value={true}
                    >
                        {props.workspaceName}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:1.5,
                    maxHeight:350,
                    overflow:'auto'
                }}
            >

                <Box>
                    <ShippedOrders
                        filterBySelectedWorkSpace={props.filterBySelectedWorkSpace}
                        shippedOrders={props.shippedOrders}
                        currentOrder={props.currentOrder}
                        setShipmentHighlightColor={props.setShipmentHighlightColor}
                        setSelectedOrder={props.setSelectedOrder}
                        workspaceId={props.workspaceId}
                    />
                </Box>
            </Box>
        </SHModal>
    );
};

export default MShippedOrdersModal;
